import { render, staticRenderFns } from "./ActivesTypeList.vue?vue&type=template&id=4008ea52"
import script from "./ActivesTypeList.vue?vue&type=script&lang=js"
export * from "./ActivesTypeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports